import { AppTypes } from 'src/types/AppTypes.ts';

export const APP_ROUTE_MAP: Record<AppTypes, string> = {
    actuators: 'actuator-sizing-and-selection',
    valves: 'sizing-and-selection',
    sensors: 'sensor-selection',
};

export const getAppRoutePrefix = (location: Location, to: AppTypes) => {
    const match = location.pathname.match(/(^\/\w+\/shop\/\w+\/)([^/]+)?/);
    const prefix = match && match[1];
    return `${prefix}${APP_ROUTE_MAP[to] || APP_ROUTE_MAP.valves}`;
};
